export const API_SERVER = process.env.REACT_APP_BACKEND_SERVER;